import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { fontWeights, typographyMixin } from "../../../design-system/tokens/typography";

export const Tab = styled.button<{ $isActive: boolean }>`
  appearance: none;
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: 0 ${spacing[4]};
  border: none;
  border-right: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  cursor: pointer;
  white-space: nowrap;
  ${({ $isActive }) => typographyMixin("caption", $isActive ? 1 : 3)}
  color: ${({ $isActive }) => ($isActive ? rawColors.text.highEmphasis : rawColors.text.mediumEmphasis)};
  background: ${({ $isActive }) => ($isActive ? rawColors.structural.themeLight : rawColors.structural.white)};
  box-shadow: ${({ $isActive }) => ($isActive ? `inset 0 ${borderWidth[2]} 0 ${rawColors.primary[500]}` : "none")};

  &:focus-visible {
    outline: ${borderWidth[2]} solid ${rawColors.primary[500]};
    outline-offset: -${borderWidth[2]};
  }
`;

/** Chip: 18px, radius 5, 10px/700. GAP: 10px size has no caption token (overline-4 is 10px but regular weight). */
export const NumberChip = styled.span<{ $isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: ${borderRadius[5]};
  ${typographyMixin("caption", 1)}
  font-size: 0.625rem;
  font-weight: ${fontWeights.bold};
  background: ${({ $isActive }) => ($isActive ? rawColors.primary[500] : rawColors.grey[300])};
  color: ${({ $isActive }) => ($isActive ? rawColors.text.white : rawColors.text.mediumEmphasis)};
`;
